import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { meetingMediaUrl } from "../../api/Meetings/meetingSessionsApi";
import {
  meetingMediaThumbFrameSx,
  meetingMediaThumbMediaSx,
} from "./meetingUiStyles";

/**
 * Miniatura de vídeo: carga el primer fotograma solo al entrar en viewport
 * (preload metadata + #t=0.1). Caja 4:3 fija como las fotos.
 */
export default function MeetingVideoThumb({ fileUrl, sx }) {
  const rootRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = rootRef.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setActive(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setActive(true);
          io.disconnect();
        }
      },
      { rootMargin: "120px 0px", threshold: 0.01 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const src = active
    ? `${meetingMediaUrl(fileUrl)}${String(fileUrl || "").includes("#") ? "" : "#t=0.1"}`
    : undefined;

  return (
    <Box ref={rootRef} sx={{ ...meetingMediaThumbFrameSx, ...sx }}>
      {src ? (
        <Box
          component="video"
          src={src}
          muted
          playsInline
          preload="metadata"
          sx={{
            ...meetingMediaThumbMediaSx,
            pointerEvents: "none",
          }}
        />
      ) : null}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "grid",
          placeItems: "center",
          pointerEvents: "none",
          zIndex: 1,
        }}
        aria-hidden
      >
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            bgcolor: "rgba(0,0,0,0.45)",
            color: "common.white",
            display: "grid",
            placeItems: "center",
            fontSize: 11,
            fontWeight: 700,
            pl: 0.25,
          }}
        >
          ▶
        </Box>
      </Box>
    </Box>
  );
}
